import HotelSortPropertiesCalculator from "../../js/components/hotelSortPropertiesCalculator";

export default class HotelInfoWindow extends HTMLElement {

    connectedCallback() {
        this.hotelSortPropertiesCalculator = new HotelSortPropertiesCalculator();
        this._shadowRoot = this.attachShadow({mode: 'open'});
        const template = document.querySelector('#hotel-info-window');
        const instance = template.content.cloneNode(true);
        this.stylesheet = this.getAttribute('stylesheet');
        this.translations = JSON.parse(this.getAttribute('translations'));
        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;
        this._shadowRoot.appendChild(instance);

    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (this._shadowRoot) {
            if (name == 'entity') {
                this.instance = this._shadowRoot
                this.hotelJson = JSON.parse(newValue);
                this.updateView();
            }
        }
    }

    updateView() {
        this.serviceTemplate = document.querySelector('#hotel-info-window-service-template').content;

        this.instance.querySelector('[name="img"]').src  = this.hotelJson.img;
        this._fillElement('button-text', this.translations.buttonText);
        this._fillElement('name', this.hotelJson.name);
        this._fillElement('address', this.hotelJson.address);
        this._fillRatingValue()
        this._fillCategoryContainer();
        this._fillServices();

        let mealPlan = this.hotelSortPropertiesCalculator.getSelectedMealPlan(this.hotelJson);
        if (!mealPlan) {
            this.__hideItemsWhenNoMealPlans();
            return;
        }

        this._fillElement('person-price', this.translations.personPrice);
        if (mealPlan.show_meal_plan_map){
            this._fillElement('meal-plan', mealPlan.name);
            this.instance.querySelector('[name="meal-plan"]').style.display = '';
        }else{
            this.instance.querySelector('[name="meal-plan"]').style.display = 'none';
        }
        let cheapestDistribution = this._getCheapestDistribution(mealPlan);

        if (cheapestDistribution) {
            if (cheapestDistribution.roomDistribution) {
                this._fillElement('price', cheapestDistribution.roomDistribution.person_price + ' €');
                if (cheapestDistribution.roomDistribution.free_cancellation) {
                    this._fillElement('free-cancellation', cheapestDistribution.roomDistribution.free_cancellation);
                }
            }

            let icon = this.instance.querySelector('[data-pista-icon]');
            icon.classList.add("hidden");
            this._fillElement('pista-distance', "");
            this._fillElement('pista-text', "");
            if (cheapestDistribution.pista) {
                if (cheapestDistribution.pista.pista_distance) {
                    icon.classList.remove("hidden");
                    this._fillElement('pista-distance', cheapestDistribution.pista.pista_distance);
                }
                if (cheapestDistribution.pista.pista_text) {
                    this._fillElement('pista-text', cheapestDistribution.pista.pista_text);
                }
                this.instance.querySelector('[name="button"]').href = cheapestDistribution.pista.url;
            }
        }
    }

    _fillRatingValue() {
        this.instance.querySelector('[name="rate-container"]').classList.remove('hide');
        if (this.hotelJson.new || this.hotelJson.management_change) {
            this._fillElement('rate', this.hotelJson.rate_title);
            this.instance.querySelector('[name="rate-container"]').classList.add('unrated');
        } else if (this.hotelJson.rate == "") {
            this.instance.querySelector('[name="rate-container"]').classList.add('hide');
        } else {
            this.instance.querySelector('[name="rate-container"]').classList.remove('unrated');
            this._fillElement('rate', this.hotelJson.rate);
        }
    }

    _getCheapestDistribution(mealPlan) {
        let cheapestRoomDistribution = null;
        
        for (let roomDistribution of mealPlan.pistas[0].room_distributions) {
            if (!cheapestRoomDistribution || roomDistribution.person_price < cheapestRoomDistribution.person_price) {
                cheapestRoomDistribution = roomDistribution;
            }
        }

        return {
            roomDistribution: cheapestRoomDistribution,
            pista: mealPlan.pistas[0]
        };
    }

    _fillServices() {
        const servicesContainer = this.instance.querySelector('[name="services-container"]');
        servicesContainer.innerHTML = '';

        if (this.hotelJson.services) {
            for (let service of this.hotelJson.services) {
                let clonedService = this.serviceTemplate.cloneNode(true);
                let icon = clonedService.querySelector('i');
                let popoverText = clonedService.querySelector('.popover-text');
                icon.classList.add('ci-' + service.icon, 'ci-s-24');
                popoverText.innerHTML = service.text;
                servicesContainer.appendChild(clonedService);
            }
        }
    }

    _fillCategoryContainer() {
        const hotelCategoryContainer = this.instance.querySelector('[name="category"]');
        hotelCategoryContainer.innerHTML = '';
        if (this.hotelJson.stars > 0) {
            this._fillCategory(hotelCategoryContainer, 'star', this.hotelJson.stars);
        } else {
            this._fillCategory(hotelCategoryContainer, 'key', this.hotelJson.keys);
        }
    }

    _fillCategory(hotelCategoryContainer, name, number) {
        for (let i = 0; i < number; i++) {
            let category = document.createElement('i');
            category.classList.add('ci', 'ci-s-15');
            category.classList.add('ci-' + name);
            hotelCategoryContainer.appendChild(category);
        }
    }

    _fillElement(elementName, elementText) {
        let element = this.instance.querySelector('[name="' + elementName + '"]');
        element.innerHTML = elementText;
    }

    __hideItemsWhenNoMealPlans() {
        this.instance.querySelector('.pista-distance').classList.add('hide');
        this.instance.querySelector('.content-center').classList.add('hide');
        this.instance.querySelector('.content-bottom').classList.add('hide');
        this.instance.querySelector('.btn-container').classList.add('hide');
    }

    static get observedAttributes() {
        return ['entity'];
    }

    get entity() {
        return this.getAttribute('entity');
    }
}
